import { createId } from "../../app/runtimeContext";
import type { ReasoningStep, ReasoningTrace } from "./types";

export class ReasoningPipeline {
  run(input: {
    organizationId: string;
    prompt: string;
    context: string[];
  }): ReasoningTrace {
    const steps: ReasoningStep[] = [
      {
        id: createId("reason"),
        name: "Understand request",
        status: "completed",
        input: input.prompt,
        output: `Request understood with ${input.context.length} context items.`,
      },
      {
        id: createId("reason"),
        name: "Identify constraints",
        status: "completed",
        input: input.context.join("\n"),
        output:
          "Security, product isolation, and repository boundaries preserved.",
      },
      {
        id: createId("reason"),
        name: "Select next action",
        status: "completed",
        input: input.prompt,
        output: "Create plan, evaluate decision, coordinate execution.",
      },
    ];
    return {
      id: createId("reasoning_trace"),
      organizationId: input.organizationId,
      prompt: input.prompt,
      steps,
      finalSummary: steps.map((step) => step.output).join(" "),
      createdAt: new Date().toISOString(),
    };
  }
}
